import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './ScrollToMessageLoader.css';

interface IScrollToMessageLoaderProps {
  onCancel: VoidFunction;
}

export const ScrollToMessageLoader: React.FC<IScrollToMessageLoaderProps> = ({ onCancel }) => {
  return (
    <div className={styles['overlay']} data-name="ScrollToMessageLoader">
      <div className={styles['loader']}>
        <div className={styles['spinner']} />
        <button
          className={styles['cancel-button']}
          onClick={onCancel}
          type="button"
          aria-label="Отмена загрузки"
          data-testid="ScrollToMessageLoaderCancelButton"
        >
          <IconActionClose16 color="icon-inverted-default" />
        </button>
      </div>
    </div>
  );
};
